import { render, staticRenderFns } from "./EditModuleView.vue?vue&type=template&id=2c9f6d41&"
import script from "./EditModuleView.vue?vue&type=script&lang=js&"
export * from "./EditModuleView.vue?vue&type=script&lang=js&"
import style0 from "./EditModuleView.vue?vue&type=style&index=0&id=2c9f6d41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports